import { useParams } from 'react-router';
import { useApi } from '@axiom/ui';

import { UserApi } from '../api/user-api';
import { CandidateUtil } from '../utils/candidate-util';

export const useCandidateId = () => {
  const [{ data: user }] = useApi(UserApi.readUser());
  const { candidateId: urlCandidateId } = useParams();
  return CandidateUtil.reconcileUserCandidateId(user, urlCandidateId);
};
